export default "__VITE_ASSET__D_pGE_Qy__"